import {
  Alert,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material'
import { FC, ReactNode, useMemo } from 'react'
import { generatePath, useNavigate } from 'react-router-dom'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../../models'
import { useListCannedJobsQuery } from '../../../redux/api/cannedJobApi'
import { CannedJobEntry } from '../../../sdk'
import { CenteredLoading } from '../../CenteredLoading/CenteredLoading'

interface Props {
  ids: string[]
}

const LinkList: FC<Props> = ({ ids }) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { data, isLoading } = useListCannedJobsQuery({
    authorization: accessToken,
    shop: shopId
  })

  const navigate = useNavigate()

  const filteredCannedJobs: CannedJobEntry[] | null = useMemo(() => {
    if (ids.length === 0) {
      return []
    }
    if (!data) {
      return null
    }
    const idSet = new Set<string>()
    ids.forEach((id) => idSet.add(id))

    return data.filter((entry) => idSet.has(entry.id!))
  }, [ids, data])

  const handleClick: (id: string) => void = (id) => {
    navigate(
      generatePath(AppRoutes.SETTINGS_CANNED_JOB_DETAIL, {
        id
      })
    )
  }

  const getContent: () => ReactNode = () => {
    if (isLoading) {
      return <CenteredLoading />
    }
    if (!filteredCannedJobs) {
      return <Alert color="warning">No results available</Alert>
    }
    return (
      <List dense>
        {filteredCannedJobs.map((entry) => (
          <ListItem key={entry.id!}>
            <ListItemButton onClick={() => handleClick(entry.id!)}>
              <ListItemText
                primary={entry.info!.name!}
                secondary={entry.info!.description!}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    )
  }

  return <>{getContent()}</>
}

export default LinkList
